import { observer } from 'mobx-react-lite';
import type { ApplicationSdk } from '../core/sdk';
import UnauthorizedPage from './Unauthorized';

const AuthView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return (
        <>
            {sdk.locationAction === 'error' ? <UnauthorizedPage sdk={sdk} /> : null}
            {sdk.locationAction === 'login' ? <>Du wirst eingeloggt</> : null}
        </>
    );
});

export default AuthView;
